/** QuickPlan — Bouton « Exporter en STEP (.stp) » : assemblage visible en solides
 *  exacts, AP214, mm, Z vers le haut, arborescence des sous-ensembles (cf. shared/step.js). */
import { useState } from 'react';
import { useProjectStore } from '../store/useProjectStore.js';
import { buildStep, stepFileName } from '../../shared/step.js';
import { hiddenSet } from '../geom.js';

export default function ExportStepButton({ className = '', label = '⤓ Exporter en STEP (.stp)' }) {
  const project = useProjectStore((s) => s.project);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    const st = useProjectStore.getState();
    setBusy(true);
    try {
      await new Promise((r) => setTimeout(r, 0)); // laisse le bouton afficher « … »
      const { text, parts, instances } = buildStep(st.project, st.lookup(), { hidden: hiddenSet(st.project) });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(new Blob([text], { type: 'model/step' }));
      a.download = stepFileName(st.project);
      a.click();
      setTimeout(() => URL.revokeObjectURL(a.href), 1000);
      st.setStatus(`Exporté : ${a.download} — ${instances} pièce(s), ${parts} définition(s)`);
    } catch (e) {
      st.setStatus(`⚠ Export STEP impossible : ${e.message}`);
    } finally {
      setBusy(false);
    }
  };
  return (
    <button
      className={className}
      disabled={busy || !project?.instances.length}
      onClick={run}
      title="Assemblage visible en solides exacts (STEP AP214) pour la CAO : FreeCAD, SolidWorks, Fusion, Inventor… — mm, Z vers le haut, sous-ensembles conservés, pièces masquées exclues"
    >
      {busy ? '…' : label}
    </button>
  );
}
